import { VideoComponent } from '@sapientpro/sapientpro-data-models';
import classNames from 'classnames';
import Video, { VideoDataProps } from '../Video/Video';
import styles from './VideoSection.module.scss';

const VideoSection = ({ data: { video } }: { data: VideoComponent }) => {
  const VideoData: VideoDataProps = {
    autoPlay: false,
    loop: true,
    clip: {
      id: video.id,
      url: video.url,
      ext: video.ext,
      alternativeText: video.alternativeText,
      caption: video.name,
    },
  };

  return (
    <section className={classNames(styles.videoSection, 'container')}>
      <Video
        video={VideoData}
        activeIndex={0}
        view='default'
        videoType='custom'
        playMode='in-view'
      />
    </section>
  );
};

export default VideoSection;
